module.exports = __webpack_public_path__ + "static/media/icono-industria.9d662f90.svg";